import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  constructor(
    // public auth = getAuth(), // you have to inject(Firestore) first before writing this line
  ) { }

  ngOnInit(): void {
  }
  async register(email: string, password: string) {
    // var result = await this.auth.createUserWithEmailAndPassword(email, password);
    // await (await this.auth.currentUser).sendEmailVerification();
  }

}
